import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';
import { leasingDetailModalVar } from '../../variables';
import moment from 'moment';
import { formatAsPercentage } from '../utils';
import { useMutation } from 'hooks/apollo';
import { DELETE_LEASING_INTEREST_TYPE_DETAIL } from '../mutations';
import useConfirmDialog from 'features/common/components/confirm/useConfirmDialog';
import FlexBox from 'components/common/FlexBox';
import { IconButton } from '@totalsoft/rocket-ui';

const LeasingInterestTypeDetailItem = ({ data }) => {
  const [t] = useTranslation();
  const confirm = useConfirmDialog();

  const [disabled, setDisabled] = useState(false);

  const [deleteMethod] = useMutation(DELETE_LEASING_INTEREST_TYPE_DETAIL, {
    onError: () => {
      setDisabled(false);
    }
  });

  const handleDelete = useCallback(() => {
    confirm(
      () => {
        setDisabled(true);
        deleteMethod({ variables: { interestTypeDetailId: data.interestTypeDetailId } });
      },
      {
        title: t('LeasingInterestTypeDetail.DeleteFloatingInterest'),
        content: t('LeasingInterestTypeDetail.AreYouSureDelete')
      }
    );
  }, [confirm, t, data, deleteMethod]);

  return (
    <TableRow hover key={data.interestTypeDetailId}>
      <TableCell> {`${data.interestTypeName}  ${data.currencyCode}`}</TableCell>
      <TableCell>{moment(data.startDate).format('DD.MM.YYYY')}</TableCell>
      <TableCell> {moment(data.endDate).format('DD.MM.YYYY')}</TableCell>
      <TableCell> {formatAsPercentage(data.interestPercent, 'decimal', 6, 6)}</TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton
            color='primary'
            disabled={disabled}
            size='small'
            variant='text'
            type='edit'
            tooltip={t('Edit')}
            onClick={() => leasingDetailModalVar({ open: true, detail: data })}
          />
          <IconButton
            color='primary'
            disabled={disabled}
            size='small'
            variant='text'
            type='delete'
            tooltip={t('Delete')}
            onClick={handleDelete}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

LeasingInterestTypeDetailItem.propTypes = {
  data: PropTypes.object
};

export default LeasingInterestTypeDetailItem;
